export function HeroSkeleton() {
  return (
    <div className="relative w-full h-[600px] sm:h-[600px] md:h-[700px] lg:h-[800px] bg-gray-200 animate-pulse">
      {/* Skeleton para la imagen de fondo del hero */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-300 via-gray-400 to-gray-500" />

      {/* Skeleton para productos superpuestos (como los azulejos en la imagen) */}
      <div className="absolute inset-0">
        {/* Producto superior derecho */}
        <div className="absolute top-8 right-8 w-24 h-16 md:w-32 md:h-20 bg-white/30 rounded-lg" />

        {/* Producto inferior izquierdo (más grande) */}
        <div className="absolute bottom-16 left-8 w-32 h-20 md:w-40 md:h-24 bg-white/40 rounded-lg" />
      </div>

      {/* Skeleton para el contenido del hero */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center space-y-6">
          {/* Título principal skeleton (NUEVA COLECCIÓN) */}
          <div className="space-y-2">
            <div className="h-10 md:h-12 lg:h-14 bg-white/30 rounded-lg w-48 md:w-64 lg:w-80 mx-auto" />
            <div className="h-10 md:h-12 lg:h-14 bg-white/30 rounded-lg w-40 md:w-52 lg:w-64 mx-auto" />
          </div>

          {/* Subtítulos skeleton (Marca Potente, Espacios que inspiran) */}
          <div className="space-y-3">
            <div className="h-5 md:h-6 bg-white/25 rounded w-32 md:w-40 mx-auto" />
            <div className="h-5 md:h-6 bg-white/25 rounded w-36 md:w-44 mx-auto" />
          </div>
        </div>
      </div>

      {/* Skeleton para flechas de navegación */}
      <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
        <div className="w-8 h-8 md:w-10 md:h-10 bg-white/30 rounded-full" />
      </div>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2">
        <div className="w-8 h-8 md:w-10 md:h-10 bg-white/30 rounded-full" />
      </div>

      {/* Skeleton para botón "Ver más" */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <div className="h-12 md:h-14 bg-gray-700/30 rounded-lg w-32 md:w-40" />
      </div>
    </div>
  );
}
